import './App.css';

function App() {
  return (
    <div className="App">
      <header className="App-header">
        <p>My portfolio</p>
      </header>
    </div>
  );
}

export default App;
